import { Component, OnInit } from '@angular/core';
import { CbicContentMstService } from 'app/entities/cbic-content-mst/service/cbic-content-mst.service';
import { ICbicContentMst } from 'app/entities/cbic-content-mst/cbic-content-mst.model';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { ChangeLanguageService } from 'app/core/util/change-language.service';
import { DomSanitizer } from '@angular/platform-browser';
import { SessionStorageService } from 'ngx-webstorage';
import { PopUpNotificationComponent } from 'app/pop-up-notification/pop-up-notification.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CbicInternalDocMappingService } from 'app/entities/cbic-internal-doc-mapping/service/cbic-internal-doc-mapping.service';
@Component({
  selector: 'cbic-home-content',
  templateUrl: './home-content.component.html',
  styleUrls: ['./home-content.component.scss']
})
export class HomeContentComponent implements OnInit {
  color: any;
  cbicTweets?: string[];
  flag: any;
  
  bannersData?: ICbicContentMst[];
  ourLeadershipData?: ICbicContentMst[];
  newsAndMediaData?: ICbicContentMst[];
  sectionImagePathList: any;
  sectionContentDivImage: any;
  usedLanguage: any;
  filePath: any;
  fileURL: any;
  sectionImagePathGallaryList: any;
  sectionContentDivPhoto: any;
  photoId: any;
  contentData: any;
  newsMediaData: any;

  citizensCornerList?: ICbicContentMst[];

  constructor(private sessionStorageService: SessionStorageService,
    private http: HttpClient, private sanitizer: DomSanitizer,
    private contentMstService: CbicContentMstService,
    private cbicInternalDocMappingService: CbicInternalDocMappingService,
    private changeLnService: ChangeLanguageService,
    private modalService: NgbModal) { }

/*this commented code block to gallery  visiblility when dome is not ready*/

    // isDataAvailable(){
    //   let dataAvailable = false;
    //   if(this.newsMediaData !=null && this.newsMediaData.length!==0){
    //    dataAvailable=true;
    //   }
    //   if(dataAvailable){
    //     dataAvailable &&= this.ourLeadershipData !=null && this.ourLeadershipData.length!==0;  
    //   } 
    //   return dataAvailable;
    //  };
  ngOnInit(): void {
    this.color = this.sessionStorageService.retrieve('colr');
    this.usedLanguage = this.changeLnService.getLanguage();
    this.getBanners();
    this.getOurLeadershipData();
   // this.getNewsAndMediaData();
    this.showPopUp();
    this.fetchTweets();
    this.getNewsAndMediaContent();
    this.getCitizenSCorner();
  }

  getBanners(): void {
    this.contentMstService.getContentDataOrderByDesc('Banners').subscribe(
      (res: HttpResponse<ICbicContentMst[]>) => {
        if (res.body) {
          this.bannersData = res.body;
          this.fetchDataForImage(this.bannersData)
        }
      }
    )
  }

  getOurLeadershipData(): void {
    this.contentMstService.getContentData('OurLeadership').subscribe(
      (res: HttpResponse<ICbicContentMst[]>) => {
        if (res.body) {
          const usedLanguage = this.changeLnService.getLanguage();
          if (usedLanguage === 'hi') {
            this.flag = 1;
          } else {
            this.flag = 2;
          }
          this.ourLeadershipData = res.body;
        }
      }
    )
  }

  getNewsAndMediaData(): void {
    this.contentMstService.getContentDataOrderByDesc('NewsAndMedia').subscribe(
      (res: HttpResponse<ICbicContentMst[]>) => {
        if (res.body) {
          this.newsAndMediaData = res.body;
          this.fetchDataForImageGallary(this.newsAndMediaData)
        }
      }
    )
  }

  getCitizenSCorner(): void {
    this.contentMstService.getContentData('citizens-corner').subscribe(
      (res: HttpResponse<ICbicContentMst[]>) => {
        if (res.body) {
          this.citizensCornerList = res.body;
        }
      }
    )
  }

  fetchDataForImage(sectionImagePath: any): void {
    if (sectionImagePath) {
      this.sectionImagePathList = [];
      for (let i = 0; i < sectionImagePath.length; i++) {
        const title=this.getI18nText(sectionImagePath[i].titleEn, sectionImagePath[i].titleHi);
        this.filePath=this.getI18nText(sectionImagePath[i].infoEn, sectionImagePath[i].infoHi);
        
        this.http.get('content/image/' + String(this.filePath),
          { responseType: 'text' })
          .subscribe(res => {
            const json = JSON.parse(res);
            this.sectionContentDivImage = 'data:application/image;base64,' + String(json.data);

            const ImageHtl = this.sanitizer.bypassSecurityTrustHtml(
              "<img seq='"+i.toString()+"' class=' w-100 img-fluid'  src='" + String(this.sectionContentDivImage) + "' type='application/image' title='"+String(title)+"'>" +

              "</img>");
            const maiList = { 
                  'orderId': i,
                  'Image': ImageHtl,
                  'Id': sectionImagePath[i].id }
            this.sectionImagePathList.push(maiList);
            
            this.sectionImagePathList.sort((a:any, b:any)=>a.orderId-b.orderId);
          }
          );
      }
    }

  }
  getI18nText(textEn: string, textHi: string ) : string{
    let title=textEn;
    if (this.usedLanguage === 'hi' && textHi) {
      title=textHi;
    }
    return title;
  }
  fetchDataForImageGallary(sectionImagePathGallary: any): void {
    if (sectionImagePathGallary) {
      this.sectionImagePathGallaryList = [];
      for (let i = 0; i < sectionImagePathGallary.length; i++) {
        const title=this.getI18nText(sectionImagePathGallary[i].titleEn, sectionImagePathGallary[i].titleHi);
        this.filePath=this.getI18nText(sectionImagePathGallary[i].infoEn, sectionImagePathGallary[i].infoHi);
        
        this.photoId = sectionImagePathGallary[i].titleEn;
        this.http.get('content/image/' + String(this.filePath),
          { responseType: 'text' })
          .subscribe(res => {
            const json = JSON.parse(res);
            this.sectionContentDivPhoto = 'data:application/image;base64,' + String(json.data);

            const ImageHtls = this.sanitizer.bypassSecurityTrustHtml(
              "<img seq='"+i.toString()+"' class='d-block w-100 img-fluid'  src='" + String(this.sectionContentDivPhoto) + "' type='application/image' title='"+String(title)+"'>" +

              "</img>");
            const photoList = {
              'Image': ImageHtls,
              'orderId': i,
              'Id': sectionImagePathGallary[i].id,
              'titleEn': sectionImagePathGallary[i].titleEn
            }
            this.sectionImagePathGallaryList.push(photoList);
            this.sectionImagePathGallaryList.sort((a:any, b:any)=>a.orderId-b.orderId);
          }
          );
      }
    }

  }


  getNewsAndMediaContent(): void {
    this.contentMstService.getContentData('News-Media').subscribe((res: HttpResponse<any>) => {
      // this.tenderData = res;
      if (res) {
        this.contentData = res.body;
      }
      console.log(Number(this.contentData[0].id))
      
      this.getNewsAndMedia(this.contentData[0].id)
      //  console.log(res);
    });
  }

  getNewsAndMedia(contentId: any): void {
    this.contentMstService.getNewsAndMediaData(contentId,0,10).subscribe((res: HttpResponse<any>) => {
      // this.tenderData = res;
      if (res) {
        this.newsMediaData = res;

      }

    });

  }
  showPopUp() {
    this.cbicInternalDocMappingService.getContentData('pop-up-Notification').subscribe(
      (res: HttpResponse<ICbicContentMst[]>) => {
        localStorage.setItem("homeres",JSON.stringify(res))
        if (res.body&&res.body.length>0) {
          const usedLanguage = this.changeLnService.getLanguage();
          if (usedLanguage === 'hi') {
            this.flag = 'Hi';
          } else {
            this.flag = 'En';
          }
          const modelRef = this.modalService.open(PopUpNotificationComponent,
            { modalDialogClass: 'popup-wrapper modal-dialog modal-dialog-centered ', size: 'lg' });
          modelRef.componentInstance.modelRef = modelRef;
          modelRef.componentInstance.cbicContentMst = res.body;
        }
      }
    )
  }
  fetchTweets(){
    this.contentMstService.fetchTweets().subscribe(
      (res: HttpResponse<string[]>)=>{
        if(!res || !res.body || res.body.length === 0){
          return;
        }

        this.cbicTweets = res.body;
      }
    );
  }
}
